import { render } from "./SuperAdmin.vue?vue&type=template&id=3d16f6d4&scoped=true"
import script from "./SuperAdmin.vue?vue&type=script&lang=js"
export * from "./SuperAdmin.vue?vue&type=script&lang=js"

import "./SuperAdmin.vue?vue&type=style&index=0&id=3d16f6d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d16f6d4"]])

export default __exports__